export const selectReducer = (state) => state.browser;

export const selectBrowserTitle = (state) =>
  selectReducer ? selectReducer(state).get('browser').title : '';
